(() => {
  if (window.__heyOfferCardCtasBound) return;
  window.__heyOfferCardCtasBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-hey-booking-service]');
    if (!trigger) return;

    const booking = document.querySelector('hey-booking');
    const serviceId = trigger.dataset.heyBookingService;
    const service = booking?.services?.find((item) => item.id === serviceId);
    if (!booking || !service) return;

    booking.selectedService = service;
    booking.selectedDate = null;
    booking.selectedSlot = null;
    booking.selectedMethod = null;
    booking.visibleMonth = booking.firstServiceMonth();
    booking.render();
  });
})();

